import NotFound from 'components/shared/NotFound';

function Error() {
  return <NotFound title="Oops. We couldn't find that page." />;
}

export default Error;
